/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useState } from 'react';
import GetPayHistoryActionBox from '../ActionIcons/GetPayHistoryActionBox/GetPayHistoryActionBox';
import './tables_styles.css';
import EmployeeNamePic from '../EmployeeNamePic/EmployeeNamePic';

import RecurringPaymentARModalController from '../../Modals/ActionRequiredModals/RecurringPaymentARModal/RecurringPaymentARModalController';
import _ from 'lodash';
import { actionRequiredService } from '../../../api/services/actionRequiredService';
import { useAppSelector } from '../../../infra/hooks';
import { useTranslate } from '../../../hooks';
import { arabicDataGrid, baseDateFormatting } from '../../helper';
import { DateField } from '../../../components';

interface Propval {
  trans: any;
}
const RecurringPayment = ({ trans }: Propval) => {
  const [openModal, setOpenModal] = useState(false);
  const [fullData, setFullData] = useState<any>({});
  const [, setHistoryData] = useState<any>({});

  const storedARData = useAppSelector(
    (state) => state.actionRequiredSlice.actionRequiredData,
  );

  const getComplaintHistoryCall = (empId: any, companyId: any) => {
    actionRequiredService
      .getClaimHistory(empId, companyId)
      .then((result) => {
        setHistoryData(result?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleTransferView = (complaint: any) => {
    setFullData(complaint);

    getComplaintHistoryCall(complaint.emp_id, complaint.company_id);
  };

  const getStatus = ['Pending', 'Approved', 'Rejected'];

  const tableColumns: any = [
    {
      field: 'empId',
      headerName: trans('Emp Id'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'empName',
      headerName: trans('Emp Name'),
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        return (
          <EmployeeNamePic
            name={params?.row?.empName}
            picture={params?.row?.empPic}
          />
        );
      },
    },
    {
      field: 'designation',
      headerName: trans('Designation'),
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'submissionDate',
      headerName: trans('Submission Date'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => (
        <DateField
          value={params?.row?.submissionDate}
          format={baseDateFormatting}
        />
      ),
    },
    {
      field: 'type',
      headerName: trans('Type'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'duration',
      headerName: trans('Duration'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'amount',
      headerName: trans('Amount'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'status',
      headerName: trans('Status'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },

    {
      field: 'action',
      flex: 1,
      headerName: trans('Action'),
      headerClassName: 'header',
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: any) => {
        return (
          <GetPayHistoryActionBox
            onView={() => {
              handleTransferView(params?.row?.fullData);
              setOpenModal(true);
            }}
          />
        );
      },

      width: 200,
      height: 70,
    },
  ];

  const row_data = _.map(storedARData, (data: any) => {
    return {
      id: data?.id,
      empId: `#${data?.staff_id}`,
      empPic: data?.profile_pic,
      empName: `${data?.first_name} ${data?.last_name}`,
      type: data?.loan_type,
      submissionDate: data?.start_date,
      amount: data?.amount,
      designation: data?.current_designation,
      fullData: data,
      duration: data?.duration,
      status: getStatus[data?.loan_status],
    };
  });

  const { isRTL } = useTranslate();

  return (
    <>
      <Box
        className="ar_table"
        sx={{
          '& .header': {
            backgroundColor: '#F5F5F5',
          },

          width: '100%',
          marginTop: '2em',
        }}
      >
        <DataGrid
          sx={{
            color: '#081735',
            font: 'normal normal normal 14px/24px Lato;',
          }}
          autoHeight
          disableExtendRowFullWidth
          disableSelectionOnClick
          localeText={isRTL ? arabicDataGrid : undefined}
          rows={row_data}
          columns={tableColumns}
          componentsProps={{
            pagination: {
              labelRowsPerPage: trans('Rows per page'),
            },
          }}
        />
      </Box>
      {openModal && (
        <RecurringPaymentARModalController
          closeModal={() => setOpenModal(false)}
          isModalOpen={openModal}
          fullData={fullData}
        />
      )}
    </>
  );
};

export default RecurringPayment;
